import classnames from 'classnames';
import PropTypes from 'prop-types';

import styles from './AudioListItem.module.scss';

const AudioTimeline = (props) => {
    const { currentTime, duration, onTimelineChange } = props;

    return (
        <div className={classnames(styles[`audio__timeline`])}>
            <span className={classnames(styles[`audio__timeline-thumb`])} />
            <span className={classnames(styles[`audio__timeline-progress-bar`])} />
            <input
                type="range"
                min="0"
                max="100"
                className={classnames(styles[`audio__timeline-input`])}
                value={currentTime && duration ? (currentTime / duration) * 100 : 0}
                onChange={onTimelineChange}
            />
        </div>
    );
};

AudioTimeline.propTypes = {
    /**
     * Audio total time
     */
    duration: PropTypes.number,
    /**
     * Audio current time
     */
    currentTime: PropTypes.number,
    /**
     * Time line update callback
     */
    onTimelineChange: PropTypes.func,
};

AudioTimeline.displayName = 'AudioTimeline';

export default AudioTimeline;
